<template>
  <div class="tw-min-h-screen tw-flex tw-flex-col tw-antialiased">
    <main
      id="content"
      class="tw-text-nl-green-100 tw-text-body-sm md:tw-text-body tw-flex-grow"
      tabindex="-1"
    >
      <ClientOnly>
        <RegflowHeader />
      </ClientOnly>
      <slot />
    </main>
    <Footer />
  </div>
</template>
<script setup lang="ts"></script>
